import React, { Component } from 'react';
import { trim } from 'lodash';
import { Drawer } from 'rmwc';
import { DrawerContent } from 'rmwc/Drawer';

// Resolves a bug where transform objects reset viewport, which kills position: fixed
export class RightDrawer extends Component {
  _handleApi(drawerApi) {
    this.drawerApi = drawerApi;
  }

  _onClick(evt) {
    if (!!evt.target.className && trim(evt.target.className) == 'mdc-drawer__drawer') {
      this.drawerApi.open = false;
    }
  }

  render() {
    const { className, children, ...otherProps } = this.props;
    const outerClass = `hrbr-right-drawer ${className !== null ? className : ''}`;
    return (
      <Drawer
        className={outerClass}
        apiRef={drawerApi => this._handleApi(drawerApi)}
        onClick={evt => this._onClick(evt)}
        children={<div className="right-drawer-inner">{children}</div>}
        {...otherProps}
      />
    );
  }
}

export const DrawerFlex = ({ children, className, ...other }) => {
  return (
    <div className={`hrbr-drawer-flex-wrapper ${className ? className : ''}`}>
      <div className="hrbr-drawer-flex">{children}</div>
    </div>
  );
};

export const DrawerFlexGrow = ({ children, className, ...other }) => {
  return (
    <div className={`hrbr-drawer-flex-grow ${className ? className : ''}`} {...other}>
      {children}
    </div>
  );
};

export const DrawerSubHeader = ({ children, ...other }) => {
  return (
    <div className="hrbr-drawer-sub-header" {...other}>
      {children}
    </div>
  );
};

export const DrawerFooter = ({ children, ...other }) => {
  return (
    <DrawerFlexGrow className="hrbr-drawer-footer" {...other}>
      <DrawerContent>{children}</DrawerContent>
    </DrawerFlexGrow>
  );
};
